/**
 * Taken from pdfjs-dist/lib/web/ui_utils.js #normalizeWheelEventDirection
 */
export const normalizeWheelEventDirection = (evt: WheelEvent) => {
  let delta = Math.hypot(evt.deltaX, evt.deltaY);
  const angle = Math.atan2(evt.deltaY, evt.deltaX);
  if (-0.25 * Math.PI < angle && angle < 0.75 * Math.PI) {
    // All that is left-up oriented has to change the sign.
    delta = -delta;
  }
  return delta;
};
